module.exports = __webpack_public_path__ + "img/06.6f456392.jpg";